import { Box, Button, Flex, IconButton, Menu, MenuButton, MenuItem, MenuList, useDisclosure } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import SupportCreateModal from '../../pages/Dashboard/Support/SupportCreateModal'
import { Icon } from '../Icon'
import { SupportHeadsetIcon } from '../icons'
import NotificationBell from '../notifications/NotificationBell'
import { Tooltip } from '../Tooltip'
import styles from './Header.module.css'

interface IUser {
  name: string
  email: string
  picture: string
  roles: string[]
}

export default function Header() {
  const [user, setUser] = useState<IUser>({ name: '', email: '', picture: '', roles: [] })
  const navigate = useNavigate()
  const { isOpen, onOpen, onClose } = useDisclosure()

  const logout = () => {
    localStorage.clear()

    navigate('/login')
  }

  useEffect(() => {
    const user = localStorage.getItem('user')

    if (user) {
      setUser(JSON.parse(user))
    }
  }, [])

  return (
    <Box as="header" className={styles.header} mb={3}>
      <Box display="inline-block">
        <Flex direction="row" align="center">
          <img src={user.picture} alt="" className={styles.profileImage} />

          <span>Bem-vindo(a), {user.name}</span>

          <NotificationBell />

          <Menu>
            {/* O `display` ia para o balão, não para o gatilho: o tooltip ficava `display: none`
                a partir de `md`, que é justamente onde existe hover. */}
            <Tooltip label="Suporte" placement="bottom">
              <MenuButton
                as={IconButton}
                aria-label="Suporte"
                colorScheme={'darkGray'}
                size={'sm'}
                icon={<SupportHeadsetIcon />}
                variant={'outline'}
                ml={3}
              />
            </Tooltip>
            <MenuList>
              <MenuItem icon={<Icon name="lni lni-plus" />} onClick={onOpen}>
                Criar novo chamado
              </MenuItem>
              <MenuItem icon={<Icon name="lni lni-support" />} onClick={() => navigate('/support')}>
                Ver chamados
              </MenuItem>
            </MenuList>
          </Menu>

          <Button onClick={logout} colorScheme="magenta" size="sm" ml={3}>
            <Icon name={`lni lni-exit ${styles.dropdownIcon}`} />
            Sair
          </Button>
        </Flex>
      </Box>
      <SupportCreateModal isOpen={isOpen} onClose={onClose} />
    </Box>
  )
}
